import axios, { AxiosRequestConfig, AxiosResponse, AxiosError } from 'axios';
import { AxiosBaseQueryResponse } from './types';
import qs from 'qs';

//Take oldObject fields and update it with new properties
export const updateObject = (oldObject: any, updatedProperties: any) => {
    return {
        ...oldObject,
        ...updatedProperties,
    };
};

export const axiosBaseQuery = ({
    baseUrl,
    arrayParamsSerializer,
}: { baseUrl?: string; arrayParamsSerializer?: boolean } = {}): ((
    axiosParams: AxiosRequestConfig,
) => Promise<AxiosBaseQueryResponse>) => {
    return async (axiosParams: AxiosRequestConfig) => {
        try {
            axiosParams.url = (baseUrl || '') + axiosParams.url;
            if (arrayParamsSerializer) {
                axiosParams.paramsSerializer = (params) => qs.stringify(params, { arrayFormat: 'repeat' });
            }
            const result: AxiosResponse = await axios.request(axiosParams);
            return { data: result.data };
        } catch (axiosError) {
            const err = axiosError as AxiosError;
            return {
                error: {
                    status: err.response ? err.response.status : undefined,
                    data: err.response ? err.response.data : undefined,
                },
            };
        }
    };
};
